import { Button, notification } from 'antd';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';

type Action = {
  label?: string;
  onClick: () => void;
};

type Config = {
  duration: number;
  message?: string;
  closeLabel?: string;
  onClose?: () => void;
};

export class SNotification {
  static success(description: string, config?: Config) {
    toast.success(
      description,
      config && {
        autoClose: config.duration === 0 ? false : config.duration,
        onClose: config.onClose,
        closeButton: !!config.closeLabel && (
          <Button
            style={{
              marginLeft: 4,
              alignSelf: 'center',
            }}
            type="primary"
            size="middle"
          >
            {config.closeLabel}
          </Button>
        ),
      },
    );
  }

  static error(description?: string, message: string = '') {
    toast.error(description);
  }

  static warn(message: string) {
    toast.warn(message);
  }

  static config() {
    // notification.config({
    //   placement: 'top',
    //   duration: 5,
    //   closeIcon: <CloseOutlined style={{ marginTop: 8, transform: 'translateX(6px)' }} size={26} />,
    // });
  }
}
